import { isPlatformBrowser } from "@angular/common";
import { Component, inject, OnInit, PLATFORM_ID } from "@angular/core";

export const GO_TO_LOGIN = 'go to login';

@Component({
    selector: 'app-show-login-callback',
    template: '<h1>Redirecting... Please wait</h1>'
})
export class ShowLoginCallbackComponent implements OnInit {
    private readonly platformId = inject(PLATFORM_ID);
    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            window.parent.postMessage(GO_TO_LOGIN);
        }
    }
}